import { io } from "socket.io-client";

const BASE = process.env.REACT_APP_BACKEND_URL;
let socket = null;

export function connectSocket(token) {
  if (!BASE || !token) return null;
  if (socket) {
    socket.auth = { token };
    if (!socket.connected) socket.connect();
    return socket;
  }
  socket = io(BASE, {
    path: "/api/socketio",
    transports: ["websocket", "polling"],
    auth: { token },
    autoConnect: true,
    reconnection: true,
  });
  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
